/**
 * Gets the beneficiary initials from name.
 * @function
 * @name getBeneficiaryInitials
 * @kind function
 * @param {string} beneficiaryName Full beneficiary display name.
 * @returns {string} initials.
 * @exports
 */
export function getBeneficiaryInitials(beneficiaryName: string): string {
  const firstInitial = beneficiaryName[0];
  const listofNames = beneficiaryName.split(" ");
  const secondName = listofNames[listofNames.length - 1];
  if (secondName && listofNames.length > 1) {
    return `${firstInitial}${secondName[0]}`;
  } else {
    return beneficiaryName[0];
  }
}
